import { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const navigationItems = [
  { name: 'Home',       path: '/' },
  { name: 'Approach',   path: '/approach' },
  { name: 'Principles', path: '/principles' },
  { name: 'History',    path: '/history' },
  { name: 'Contact',    path: '/contact' },
];

/**
 * Custom hook for navigation state management
 * Centralizes all navigation logic and state
 */
const useNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const currentPage = useMemo(() => {
    const item = navigationItems.find(item => item.path === location.pathname);
    return item ? item.name : 'Home';
  }, [location.pathname]);

  const openNavigation = () => setIsOpen(true);
  const closeNavigation = () => setIsOpen(false);
  const toggleNavigation = () => setIsOpen(!isOpen);

  return {
    isOpen,
    currentPage,
    navigationItems,
    openNavigation,
    closeNavigation,
    toggleNavigation
  };
};

export default useNavigation;